import React, { useEffect, useRef, useState } from "react";
import "./style.css";
import {
  faCircleExclamation,
  faEye,
  faFile,
  faFolderOpen,
  faPaperclip,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Swal from "sweetalert2";
import loadConfig from "../../Services/Api/ApiServices";
import { useSelector } from "react-redux";

export default function AttachmentASFH(props) {
  const [singleFile, setSingleFile] = useState(props.singleFile);
  const [dataJsonObject, SetDataJsonObject] = useState();
  const JsonDataa = useSelector((state) => state.FetchDataJson);
  const lang = useSelector((state) => state.languageReducer.Language);

  useEffect(() => {
    const fetchData = async () => {
      let jsonData = await loadConfig();
      SetDataJsonObject(jsonData);
    };
    fetchData();
  }, []);

  // 🔹 Update file if props.singleFile changes dynamically
  useEffect(() => {
    setSingleFile(props.singleFile);
  }, [props.singleFile]);

  // 🔹 Clear file when props.clear is true
  useEffect(() => {
    if (props.clear) {
      setSingleFile(null);
    }
  }, [props.clear]);

  // 🔹 Handle file validation + send to parent
  const handleSingleFileChange = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const allowedExtensions = [
      "pdf",
      "doc",
      "docx",
      "xls",
      "xlsx",
      "jpg",
      "jpeg",
      "png",
    ];
    const maxFileSize = 10 * 1024 * 1024; // 10MB
    const extension = file.name.split(".").pop().toLowerCase();

    const messages = {
      invalidFile: {
        ar: `الملف غير مدعوم ، الملفات المدعومة هي : ${allowedExtensions.join(
          " ، "
        )}`,
        en: `Unsupported file type. Supported types: ${allowedExtensions.join(
          ", "
        )}`,
      },
      largeFile: {
        ar: "حجم الملف كبير ، يجب ان يكون حجم المرفق 10 MB او اقل.",
        en: "File size is too large. Maximum allowed size is 10 MB.",
      },
      errorTitle: {
        ar: "خطأ",
        en: "Error",
      },
      confirmText: {
        ar: "موافق",
        en: "OK",
      },
    };

    if (!allowedExtensions.includes(extension)) {
      Swal.fire({
        title: messages.errorTitle[lang],
        text: messages.invalidFile[lang],
        icon: "error",
        confirmButtonText: messages.confirmText[lang],
      }).then(() => (e.target.value = null));
      return;
    }

    if (file.size > maxFileSize) {
      Swal.fire({
        title: messages.errorTitle[lang],
        text: messages.largeFile[lang],
        icon: "error",
        confirmButtonText: messages.confirmText[lang],
      }).then(() => (e.target.value = null));
      return;
    }

    // Valid file
    props.onChange(e);
    setSingleFile(file);
  };

  // 🔹 Open file (either from frontend or backend)
  const openFileInNewTabFront = (file) => {
    if (!file) return;
    if (file instanceof File) {
      const fileURL = URL.createObjectURL(file);
      window.open(fileURL, "_blank");
    } else {
      window.open(
        `${dataJsonObject?.domainUrl}/${props.AttachementType}/${file}`,
        "_blank"
      );
    }
  };


const handleDownload = async () => {
  console.log(props.FileName,"sssssssssssssdwd");
    
  window.open(
    `${dataJsonObject?.domainUrl}/api/UploadDownload/download/${props.FolderName}/${props.FileName}`,
    "_blank"
  );
};


  return (
    <>
      {props.show && (
        <>
          {/* Label */}
          <div className="label-container">
            <label
              className="labeInput"
              htmlFor={props.fieldsName}
              style={{ textAlign: lang !== "en" ? "right" : "left" }}
              title={
                lang === "ar"
                  ? JsonDataa?.JsonData[props.fieldsName]?.nameEN
                  : JsonDataa?.JsonData[props.fieldsName]?.nameAR
              }
            >
              {lang !== "en"
                ? JsonDataa?.JsonData[props.fieldsName]?.nameAR
                : JsonDataa?.JsonData[props.fieldsName]?.nameEN}
              {JsonDataa?.JsonData[props.fieldsName]?.isRequired &&
                !props.showAsterisk && <span style={{ color: "red" }}>*</span>}
            </label>

            {props.showValidationMessage && (
              <span
                className="validation-icon"
                data-tooltip={props.validationMessage}
              >
                <FontAwesomeIcon icon={faCircleExclamation} />
              </span>
            )}
          </div>

          {/* File Upload */}
          <label
            className={`custum-file-upload 
              ${props.disabled ? "uploadDisabled" : ""} 
              ${props.showValidationMessage ? "input-error" : ""}`}
            htmlFor={`singleFile-${props.id}`}
            title={props.title}
          >
            <div className="text">
              <div className="icon">
                <FontAwesomeIcon
                  icon={faPaperclip}
                  style={{ color: "#f9a825" }}
                />
                &nbsp;
              </div>
              <span>
                {singleFile && singleFile !== "null"
                  ? props.textEdit
                    ? props.textEdit
                    : lang !== "en"
                    ? "انقر لتعديل المرفق"
                    : "Edit Attachment"
                  : props.text
                  ? props.text
                  : lang !== "en"
                  ? "انقر لاضافة مرفق"
                  : "Add Attachment"}
              </span>
            </div>

            <input
              type="file"
              id={`singleFile-${props.id}`}
              title={singleFile ? props.title : "انقر لإضافة المرفق"}
              disabled={props.disabled || props.readOnly}
              onChange={handleSingleFileChange}
            />

            {/* Preview Button */}
            {singleFile && singleFile !== "null" && (
              <button
                type="button"
                className="preview-btn"
                title="عرض المرفق"
                onClick={() => openFileInNewTabFront(singleFile)}
                // onClick={handleDownload}
              >
                <FontAwesomeIcon
                  // icon={faFolderOpen}
                  // icon={faFile}
                  icon={faEye}
                  style={{ color: "#f9a825" }}
                />
              </button>
            )}
          </label>
        </>
      )}
    </>
  );
}
